<template>
  <div
    v-if="errorMessages.length"
    :class="DS_FILE_UPLOAD_CLASSES.ErrorList"
    :data-cy="props.dataCy"
  >
    <DSFormFieldError
      v-for="(error, index) in errorMessages"
      :key="`${props.errorKeyPrefix}-error-${index}`"
      :error-message="error"
    />
  </div>
</template>

<script setup lang="ts">
import { computed } from "vue";
import DSFormFieldError from "@/src/design_system/form_elements/form_field_error/components/DSFormFieldError.vue";
import { DS_FILE_UPLOAD_CLASSES } from "../constants/classes";

interface DSFileUploadErrorListProps {
  errorMessages?: string[];
  errorKeyPrefix: string;
  dataCy?: string;
}

const props = defineProps<DSFileUploadErrorListProps>();
const errorMessages = computed(() => props.errorMessages ?? []);
</script>
